import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumbs, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const BreadcrumbComponent = () => {
  const location = useLocation();
  const theme = useTheme();
  
  // Mapeamento de rotas para nomes amigáveis
  const routeNames = {
    '': 'Início',
    'transparency': 'Portal da Transparência',
    'accessibility': 'Acessibilidade',
    'mesaDiretora': 'Mesa Diretora',
    'institucional': 'Institucional',
    'mapadosite': 'Mapa do Site',
    'vereadores': 'Vereadores',
    'todosvereadores': 'Todos os Vereadores',
    'noticias': 'Notícias',
    'noticia': 'Notícia',
    'faleconosco': 'Fale Conosco',
    'detalhes': 'Detalhes da Publicação',
    'publicacoes': 'Publicações',
    'TermosPrivacidade': 'Termos de Privacidade',
    'search-results': 'Resultados da Pesquisa',
    // Nomes específicos de vereadores
    'crisazevedo': 'Cris Azevedo',
    'edilmolira': 'Edilmo Lira',
    'erivanelias': 'Erivan Elias da Silva',
    'jailsonmendonca': 'Jailson Mendonça da Silva',
    'janainabezerra': 'Janaína Patrícia Bezerra da Silva',
    'leandroeuclides': 'Leandro Euclides Guedes da Costa',
    'marciacosta': 'Marcia Costa Araujo Gomes',
    'ovidiodeaquino': 'Ovídio de Aquino e Silva Neto',
    'wagnerferreira': 'Wagner Ferreira Gonçalves'
  };

  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    
    // Se estiver na página inicial, não mostrar breadcrumb
    if (pathnames.length === 0) {
      return [];
    }

    const breadcrumbs = [
      {
        name: 'Início',
        path: '/'
      }
    ];

    let currentPath = '';
    
    pathnames.forEach((pathname, index) => {
      currentPath += `/${pathname}`;
      
      // Verificar se é um parâmetro dinâmico (ID numérico)
      const isNumericId = /^\d+$/.test(pathname);
      
      let displayName = routeNames[pathname] || pathname;
      
      // Se for um ID numérico, usar um nome genérico
      if (isNumericId) {
        const previousPath = pathnames[index - 1];
        if (previousPath === 'noticia') {
          displayName = 'Detalhes da Notícia';
        } else if (previousPath === 'vereadores') {
          displayName = 'Detalhes do Vereador';
        } else {
          displayName = 'Detalhes';
        }
      }
      
      // Capitalizar primeira letra se não estiver no mapeamento
      if (!routeNames[pathname] && !isNumericId) {
        displayName = pathname.charAt(0).toUpperCase() + pathname.slice(1);
      }

      breadcrumbs.push({
        name: displayName,
        path: currentPath,
        isLast: index === pathnames.length - 1
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Não renderizar se não houver breadcrumbs
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: theme.palette.grey[100],
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        padding: '12px 16px',
        position: 'fixed',
        top: { xs: '15vh', sm: '12vh', md: '16vh', lg: '12vh', xl: '15vh' }, // Ajustar baseado na altura do AppBar
        zIndex: 1,
        transition: 'top 0.3s ease'
      }}
    >
      <Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{
            '& .MuiBreadcrumbs-separator': {
              color: theme.palette.grey[600]
            }
          }}
        >
          {breadcrumbs.map((breadcrumb, index) => {
            if (breadcrumb.isLast) {
              return (
                <Typography
                  key={breadcrumb.path}
                  color="text.primary"
                  sx={{
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }}
                >
                  {breadcrumb.name}
                </Typography>
              );
            }

            return (
              <Link
                key={breadcrumb.path}
                to={breadcrumb.path}
                style={{
                  textDecoration: 'none',
                  color: theme.palette.primary.main,
                  fontSize: '0.875rem',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = theme.palette.primary.dark;
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = theme.palette.primary.main;
                }}
              >
                {breadcrumb.name}
              </Link>
            );
          })}
        </Breadcrumbs>
      </Box>
    </Box>
  );
};

export default BreadcrumbComponent;